import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';

export interface DropdownBreadcrumItemSelected {
	item: any;
	index: number;
}

let dropdownIds = 0;

@Component({
	selector: 'cv-dropdown-breadcrumb',
	styleUrls: ['./dropdown-breadcrumb.component.scss'],
	templateUrl: './dropdown-breadcrumb.component.html'
})
export class DropdownBreadcrumbComponent {
	/**
   * @public identifier for dropdown
   */
	public dropdownId = `cv-dropdown-${dropdownIds++}`;

	/**
   * @public property that recieves the title text
   */
	@Input() title = '';
	/**
   * @public property that recieves key of the item to show value
   */
	@Input() itemTextKey = '';
	/**
   * @public property that recieves the list of items to display
   */
	@Input() items: Array<any> = [];
	/**
   * @public property that emit an event when an item is selected
   */
	@Output() itemSelected: EventEmitter<DropdownBreadcrumItemSelected> = new EventEmitter<DropdownBreadcrumItemSelected>();

	/**
   * @public append the popper-content element to a given selector
   */
	@Input() appendTo = '';

	/**
   * Constructor
   * default method of the class that is executed when the class is instantiated
   */
	constructor(private elementRef: ElementRef) {}

	/**
   * selectItem
   * method executed when you select an item
   */
	selectItem(item: any, index: number): void {
		this.itemSelected.emit({ item, index });
	}

	/**
	 * TEST for general propouses
	 * Actions available:
	 * 	action-toggle
	 * 	action-select
	 * 	item-value
	 * 
	 * Selectors
	 * 	$('.cv-dropdown-breadcrumb-component button.action-toggle')
	 * 	$('.cv-dropdown-breadcrumb-component button.item-value')
	 * 	Once you have opened the breadcrumb, have to proceed to select one of the items from the list.
	 * 	$('.cv-dropdown-breadcrumb-component .cv-dropdown__options__list .action-select')
	 * 	$('.cv-dropdown-breadcrumb-component .cv-dropdown__options__list .item-value')
	 */

	/**
	 * Test for OBJECT NAVIGATION
	 * jQuery('.cv-object-navigation-component .breadcrumb .breadcrumb-item cv-dropdown-breadcrumb .action-toggle').trigger('click') // Here it can return multiple elements
	 * Once you have opened the breadcrumb, have to proceed to select one of the items from the list.
	 * jQuery('.cv-object-navigation-component .breadcrumb-item cv-dropdown-breadcrumb .cv-dropdown__options__list .action-select').click()
	 * The parent Object Navigation will be updated automatically.
	 */
}
